import { OrderDoc, OrderProduct } from '@gooduncles/gu-app-schema';
import { create } from 'zustand';

/**
 * 모달이 열린 경로를 나타내는 타입
 */
export type IssueModalSource =
  | '주문 관리/주문별 보기'
  | '주문 관리/상품별 보기'
  | '사용자 관리';

export interface IssueModalState {
  open: boolean;
  order: OrderDoc | null;
  store: { storeId: string; storeName: string } | null;
  product: OrderProduct | null;
  changeType: 'volume_change' | 'sold_out';
  newVolume?: number;
  source: IssueModalSource | null;
}

interface OrderProductIssueModalStore {
  state: IssueModalState;
  open: (params: Omit<IssueModalState, 'open'>) => void;
  close: () => void;
}

const initialState: IssueModalState = {
  open: false,
  order: null,
  store: null,
  product: null,
  changeType: 'volume_change',
  source: null,
};

export const useOrderProductIssueModal = create<OrderProductIssueModalStore>((set) => ({
  state: initialState,
  open: (params) => set({ state: { open: true, ...params } }),
  close: () => set({ state: initialState }),
}));
